import React from 'react';

interface CharacterCounterProps {
    count: number;
    maxCount: number;
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({ count, maxCount }) => {
    return (
        <div className="character-counter" style={{ fontSize: '0.8rem', color: '#666', textAlign: 'right', width: '100%', paddingRight: '5px' }}>
            {count} / {maxCount}
        </div>
    );
};

export default CharacterCounter; 